import { makeStyles } from '@material-ui/core/styles';
import theme from '../../theme/booking-theme';

const paymentStyles = makeStyles({
  rootPayment: {
    display: 'flex',
    flexDirection: 'column',
  },

  contentWrapper: {
    maxWidth: '1440px',
    margin: '0 auto',
    width: '100%',
    minHeight: 'calc(100vh - 176px)', // viewport height - (height of header + footer)
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },

    '& aside': {
      width: '380px',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        paddingTop: 20,
        paddingLeft: 32,
        paddingRight: 32,
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: 20,
        paddingLeft: 20,
        paddingRight: 20,
      },
    },
    '& main': {
      flex: 1,
      paddingLeft: 64,
      paddingRight: 64,
      marginBottom: 60,
      [theme.breakpoints.down('lg')]: {
        paddingLeft: 20,
        paddingRight: 30,
      },
      [theme.breakpoints.down('md')]: {
        paddingLeft: 32,
        paddingRight: 32,
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 20,
        paddingRight: 20,
      },
      '&. rootPageSection': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
  },
  mainUP: {
    flex: 1,
    paddingLeft: 64,
    paddingRight: 64,
    marginBottom: 60,
    paddingTop: 40,

    [theme.breakpoints.down('lg')]: {
      paddingLeft: 20,
      paddingRight: 30,
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: 30,
      paddingLeft: 32,
      paddingRight: 32,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
      paddingRight: 20,
      '& .MuiBox-root .MuiFormGroup-root .MuiBox-root .MuiFormControlLabel-root': {
        width: 'auto',
      },
    },
    '&. rootPageSection': {
      fontSize: theme.typography.pxToRem(16),
    },
    '& .MuiTableCell-root:last-child': {
      paddingRight: '16px',
    },
    '& .upc__how_would_you_like_to_pay_banner .MuiPaper-root div .MuiBox-root': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  pageSectionWrapper: {
    paddingTop: 40,
    maxWidth: '852px',
    [theme.breakpoints.down('md')]: {
      paddingTop: 60,
    },
    '& h1': {
      fontSize: theme.typography.pxToRem(36),
      lineHeight: theme.typography.pxToRem(43),
      fontFamily: theme.typography.proxima.semiBold,
      marginBottom: '20px',
      [theme.breakpoints.down('lg')]: {
        fontSize: theme.typography.pxToRem(30),
        lineHeight: theme.typography.pxToRem(36),
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(24),
        lineHeight: theme.typography.pxToRem(29),
      },
    },
    '& p': {
      fontFamily: theme.typography.proxima.regular,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(21),
      marginBottom: '20px',
      [theme.breakpoints.down('lg')]: {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(19),
      },
    },
  },
  itinerary: {
    height: 'calc(100% - 60px)',
    '& div': {
      borderTop: 'none',
    },
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      width: '100%',
      maxWidth: '100%',
      display: 'block',
    },
  },

  header: {
    zIndex: '10',
    marginBottom: 20,
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 20,
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
    },
    '&  .MuiToolbar-regular': {
      maxWidth: '1440px',
      paddingRight: 36,
      paddingLeft: 36,
      [theme.breakpoints.down('lg')]: {
        paddingLeft: 30,
        paddingRight: 30,
      },
      [theme.breakpoints.down('md')]: {
        paddingLeft: 32,
        paddingRight: 32,
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 20,
        paddingRight: 20,
      },
    },
  },
  backLabel: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(19),
  },

  tooltipWrapper: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(19),
    color: theme.palette.grey1,
    fontFamily: theme.typography.proxima.regular,
    padding: '10px 0',
    minWidth: '200px',
  },

  tootipTilte: {
    fontFamily: theme.typography.proxima.semiBold,
    paddingBottom: 20,
    color: theme.palette.primary.main,
    position: 'relative',
    '& > img': {
      maxHeight: 20,
      maxWidth: 50,
      position: 'absolute',
      top: '-5px',
      right: 0,
      [theme.breakpoints.down('lg')]: {
        marginLeft: '10px',
        position: 'relative',
        top: 0,
      },
    },
  },
  tooltipRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 15,
    '& span:first-child': {
      paddingRight: '10px',
    },

    '& span:last-child': {
      fontFamily: theme.typography.proxima.semiBold,
    },
  },

  tooltipTotal: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: theme.typography.proxima.semiBold,
    padding: '0 0 15px',
    '& span:first-child': {
      paddingRight: '10px',
    },
  },
  tooltipRemainingBalance: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: theme.typography.proxima.semiBold,
    '& span:first-child': {
      paddingRight: '10px',
    },
  },

  tooltipLabel: {
    display: 'flex',
    alignItems: 'center',
  },

  infoIcon: {
    marginLeft: 10,
    color: theme.palette.blue2,
    width: 16,
    height: 16,
  },
  paymentFooterAmend: {
    padding: '24px 40px',
    boxShadow: 'initial',

    '& .MuiCheckbox-root': {
      padding: '10px 4px',
      [theme.breakpoints.only('xl')]: {
        padding: '4px',
      },
    },

    '& .MuiFormControlLabel-root': {
      alignItems: 'center',
    },
    [theme.breakpoints.down('md')]: {
      '& p': {
        fontSize: theme.typography.pxToRem(16),
      },
      '& button.MuiLink-root': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    [theme.breakpoints.only('lg')]: {
      paddingRight: '30px',
      paddingLeft: '50px',
      width: '100%',
    },
    [theme.breakpoints.only('xl')]: {
      padding: '24px 48px',
      maxWidth: '1440px',
      width: '-webkit-fill-available',
      paddingRight: '64px',
      paddingLeft: '40px',
      boxShadow: 'initial',
    },
  },
  giftCards: {
    marginBottom: '30px',
  },
  desktopNotification: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  defaultNotification: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: '-20px',
      marginBottom: '20px',
    },
    [theme.breakpoints.only('md')]: {
      paddingTop: 20,
      paddingRight: 32,
      paddingLeft: 32,
    },
  },
  affirmOption: {
    marginBottom: '30px',
    '& .affirmTotalBalance': {
      margin: 0,
      fontSize: theme.typography.pxToRem(16),
      fontFamily: theme.typography.proxima.semiBold,
      color: theme.palette.grey1,
      fontWeight: 600,
    },
    '& .affirm-modal-trigger': {
      textDecoration: 'none',
      color: theme.palette.blue2,
    },
    '& > img': {
      maxHeight: 20,
      maxWidth: 50,
    },
    [theme.breakpoints.down('lg')]: {
      '& .MuiFormGroup-root': {
        display: 'grid',
      },
      '& .affirm-modal-trigger': { display: 'block' },
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      '& .MuiFormGroup-root': {
        paddingTop: '38px',
      },
    },
  },
  affirmCustom: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: theme.typography.proxima.semiBold,
    color: theme.palette.blue1,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'Baseline',
    '& > img': {
      maxHeight: 20,
      maxWidth: 50,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'inline',
      '& .labelAffirmCustom': {
        display: 'inline-block',
        width: '168px',
      },
    },
  },
});

export default paymentStyles;
